export const AUTH_MESSAGE_TYPE = 'CDLX_AUTH_DATA';
export const IS_EMBEDDED_SESSION_KEY = 'SELFSERVE_IS_EMBEDDED';

export type AuthUser = Record<string, unknown>;

export interface AuthDataPayload {
  token: string;
  user: AuthUser;
  expiresAt?: number;
}

export interface AuthMessage {
  type: typeof AUTH_MESSAGE_TYPE;
  payload: AuthDataPayload;
}
